import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_signs_rule',
    dependencies: [
        'levels_maths/berengere_maths/power_square',
        'levels_maths/berengere_maths/signs_rule'
    ]
})


function commonMinusOne (q, pow) {
    let result = Math.pow(-1, pow)
    q.addMathFormula('(-1)^\\color{blue}[' + pow + ']')
    q.answer = [
        result,
        q.evalAnswer(result)
    ]
}



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoice([2, 4, 6])
        commonMinusOne(q, pow)
    }
})



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoice([3, 5, 7])
        commonMinusOne(q, pow)
    }
})



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoice([22, 44, 66, 88, 100])
        commonMinusOne(q, pow)
    }
})



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoice([33, 55, 77, 99])
        commonMinusOne(q, pow)
    }
})



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoice([22, 44, 66, 88, 100, 33, 55, 77, 99])
        commonMinusOne(q, pow)
    }
})



//Calculer une puissance avec une base négative et des exposants pairs.
// level.addQuestion({
//     generator: function (q) {
//         let base = random.fairChoiceInt(-10, -1)
//         let pow

//         if (base <= -4) {
//             pow = 2
//         } else {
//             pow = 4
//         }

//         q.addMathFormula('(' + base + ')^\\color{blue}[' + pow + ']')

//         let result = Math.pow(base, pow)
//         q.answer = [
//             '+' + result,
//             q.evalAnswer(result)
//         ]

//     },
//     times: 3

// })




//Calculer une puissance avec une base négative et un exposant impair (3) et 5 sur (-1).

// level.addQuestion({
//     generator: function (q) {
//         let base = random.fairChoiceInt(-4, -1)
//         let pow

//         if (base < -1) {
//             pow = 3
//         } else {
//             pow = 5
//         }

//         q.addMathFormula('(' + base + ')^\\color{blue}[' + pow + ']')

//         let result = Math.pow(base, pow)
//         q.answer = [
//             result,
//             q.evalAnswer(result)
//         ]
//     },
//     times: 3

// })



// Le résultat doit pouvoir être affiché sous forme de puissance pour éviter les calculs. Calcul avec des puissances paires.
// level.addQuestion({
//     generator: function (q) {
//         let base = random.fairChoiceInt(-25, -13, {name: 'base'})
//         let pow = random.fairChoice([10, 22, 44, 66, 88, 100], {name: 'pow'})

//         q.addMathFormula('(' + base + ')^\\color{blue}[' + pow + ']')
//         q.addText('\n')
//         q.addText('? puissance ?')

//         let positiveBase = Math.abs(base)
//         q.answer = [
//             '+' + positiveBase + ' puissance ' + pow,
//             positiveBase + 'puissance' + pow,
//             positiveBase + ' puissance ' + pow,
//             positiveBase + 'puissance ' + pow,
//             positiveBase + ' puissance' + pow,
//             positiveBase + ' Puissance ' + pow,
//             positiveBase + 'Puissance' + pow,
//             positiveBase + 'Puissance ' + pow,
//             positiveBase + ' Puissance' + pow,
//             '+' + positiveBase + 'puissance' + pow,
//             '+' + positiveBase + 'puissance ' + pow,
//             '+' + positiveBase + ' puissance' + pow,
//             '+' + positiveBase + ' Puissance ' + pow,
//             '+' + positiveBase + 'Puissance' + pow,
//             '+' + positiveBase + 'Puissance ' + pow,
//             '+' + positiveBase + ' Puissance' + pow,
//             '+ ' + positiveBase + 'puissance' + pow,
//             '+ ' + positiveBase + 'puissance ' + pow,
//             '+ ' + positiveBase + ' puissance' + pow,
//             '+ ' + positiveBase + ' Puissance ' + pow,
//             '+ ' + positiveBase + 'Puissance' + pow,
//             '+ ' + positiveBase + 'Puissance ' + pow,
//             '+ ' + positiveBase + ' Puissance' + pow
//         ]
//     },
//     times: 2,
//     errorExpected: true

// })


// Le résultat doit pouvoir être affiché sous forme de puissance pour éviter les calculs. Calcul avec des puissances impaires.
// level.addQuestion({
//     generator: function (q) {
//         let base = random.fairChoiceInt(-25, -13, {name: 'base'})
//         let pow = random.fairChoice([11, 33, 55, 77, 99], {name: 'pow'})

//         q.addMathFormula('(' + base + ')^\\color{blue}[' + pow + ']')
//         q.addText('\n')
//         q.addText('? puissance ?')

//         let positiveBase = Math.abs(base)
//         q.answer = [
//             base + ' puissance ' + pow,
//             base + 'puissance' + pow,
//             base + 'puissance ' + pow,
//             base + ' puissance' + pow,
//             base + ' Puissance ' + pow,
//             base + 'Puissance' + pow,
//             base + 'Puissance ' + pow,
//             base + ' Puissance' + pow,
//             '-(' + positiveBase + ')puissance' + pow,
//             '-( ' + positiveBase + ' )puissance' + pow,
//             '-( ' + positiveBase + ' )Puissance' + pow,
//             '-(' + positiveBase + ')Puissance' + pow,
//             '- (' + positiveBase + ')Puissance' + pow,
//             '- (' + positiveBase + ') Puissance' + pow,
//             '- (' + positiveBase + ')puissance' + pow,
//             ' -(' + positiveBase + ')puissance' + pow,
//             ' -( ' + positiveBase + ' )puissance' + pow,
//             ' -( ' + positiveBase + ' )Puissance' + pow,
//             ' -(' + positiveBase + ')Puissance' + pow,
//             ' - (' + positiveBase + ')Puissance' + pow,
//             ' - (' + positiveBase + ') Puissance' + pow,
//             ' - (' + positiveBase + ')puissance' + pow
//         ]
//     },
//     times: 2

// })

export default level


